import { Component, OnInit, OnChanges, Input, Output, EventEmitter, SimpleChanges, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { Questions } from 'src/app/common-class/questions';
import {ParticipationDataService} from 'src/app/_services/participation-data.service';
import { formatDate } from '@angular/common';
import { IfStmt } from '@angular/compiler';
import { Group } from 'src/app/common-class/pages';
declare var $: any;

@Component({
  selector: 'app-text-box',
  templateUrl: './text-box.component.html',
  styleUrls: ['./text-box.component.css'],
  //changeDetection: ChangeDetectionStrategy.OnPush
})
export class TextBoxComponent implements OnInit, OnChanges {

  @Input() JsonData: string;
  @Input() isMandatoryUpfront: boolean;
  @Input() isDisplayQno: boolean;
  @Input() isDisplaySubQno: boolean;
  @Input() isMobile: boolean;
  @Input() isMTB: boolean;
  @Input() isGrid:boolean
  @Input() isOtherControl: boolean;
  @Input() isDemographics: boolean;
  @Input() MonthArray:string[];
  @Input() isNewParticipationButton: boolean;
  @Input() group: Group;
  @Input() isAnySubQMandatory:boolean;

  @Output() ChangeAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();
  @Output() ChangeLoadingAnswersData: EventEmitter<Questions> = new EventEmitter<Questions>();
  @Output() AnsChangecall: EventEmitter<boolean> = new EventEmitter<boolean>();

  questions: Questions;
  remainingCharacters: number;
  range: boolean;
  selectedYear: any;
  SelectedMonth: any;
  SelectedDate: any;
  setDateText: any;
  ControlDate: any;
  DateFormat: string;
  DateFormatType: any;
  NoOfDays = new Array(31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31);
  fileToUpload: File = null;
  isrtl: boolean = false;
  ReEnterBlankMessage: string = "";
  isFormSubmit: boolean = false;
  isFormSubmitSub: any;
  isPreview: boolean;
  isAriaRequired: boolean = false;
  isNewParticipation: boolean;
  surveyFormat:number = 0;
  newParticipationBtnText: string;
  textBoxWidth: string;
  isAnsChange: boolean;
  inValidCount: number = 0;
  inValidRenterCount: number = 0;
  resetPageSub: any;
  CustomAttachmentSizeSurveyID : string;
  strSurveyID:string;
  strCorpNo:string;
  isNegativeCurrencyValue: boolean;
  ReenterTextMulti: string = "";
  resetPage: boolean =  false;

  ngOnChanges(changes: SimpleChanges) {

    let change = changes['JsonData'];

    let curVal = JSON.stringify(change.currentValue);
    let preVal = JSON.stringify(change.previousValue);

    if (curVal != preVal && preVal != undefined) {
      this.questions = JSON.parse(this.JsonData);
      this.resetPage = false;

      if (this.questions.qsubtype == 1 || this.questions.qsubtype == 2 ||this.questions.qsubtype == 3 || this.questions.qsubtype == 4) {
        this.setDate()
      }

      if (this.questions.qsubtype == 22 && this.questions.AnswerText != null &&
         this.questions.AnswerText != "" && this.questions.AnswerText != undefined && this.questions.isValid) {
        let curValue1 = parseFloat(this.questions.AnswerText);
        if (curValue1 < 0) {
          this.isNegativeCurrencyValue = true;
        }
      }
    }

    if(this.questions){
      this.setRemainingCharacters();
    }

  }

  constructor(public service: ParticipationDataService,
    private changeDetect: ChangeDetectorRef) {}

  ngOnInit() {

    if (this.questions == null) {
      this.questions = JSON.parse(this.JsonData);
      if (this.questions.qsubtype == 11) {
        this.questions.num_range_1 = '1';
        this.questions.num_range_2 = '5';
      }

      if (this.questions.qsubtype == 12) {
        this.questions.num_range_1 = '1';
        this.questions.num_range_2 = '9';
      }

      if (this.questions.qsubtype == 19) {
        this.questions.num_range_2 = '10';
      }

      this.setRemainingCharacters();

      if (this.questions.qsubtype == 31 && this.questions.AnswerText == null  && this.questions.PrePopText == null) {
        this.questions.isReEnterEmail = true;
      }

      if (this.service.getRTL()) {
        this.isrtl = true;
      }
      this.CustomAttachmentSizeSurveyID = this.service.CustomAttachmentSizeSurveyID;
      this.strSurveyID = this.service.strSurveyID;
      this.strCorpNo = this.service.strCorpNo;

      //PRT 102718
      if(this.service.getReEnterBlankMessage()){
        this.ReEnterBlankMessage = this.service.getReEnterBlankMessage();
      }
      this.textBoxWidth = this.getTextBoxWidth();
      if(this.questions.reEnterEmailLabel == undefined || this.questions.reEnterEmailLabel == null
        || this.questions.reEnterEmailLabel == "")
        {
            this.ReenterTextMulti=this.service.getSurveyMessages().ReenterTextMulti;
        }
        else
        {
          this.ReenterTextMulti = this.questions.reEnterEmailLabel;
        }


      if (this.questions.qsubtype == 22
        && this.questions.AnswerText != null && this.questions.AnswerText != "" &&
        this.questions.AnswerText != undefined && this.questions.isValid) {
        let curValue1 = parseFloat(this.questions.AnswerText);
        if (curValue1 < 0) {
          this.isNegativeCurrencyValue = true;
        }
      }
    }

    // Subscibe To Form Submit/Next Event ( Event is fired when mandatory is not satisfied )
    this.isFormSubmitSub = this.service.emitFormSubmitEvent.asObservable().subscribe((data) => {
      this.isFormSubmit = data;
    });

    this.isPreview = this.service.GroupType.toUpperCase() == 'PREVIEW';
    this.isNewParticipation = this.service.isNewParticipation;
    this.surveyFormat = this.service.surveyFormat;
    this.newParticipationBtnText = this.service.newParticipationBtnText;
  }

  ngAfterViewInit() {
    $('div.dtpContainer').hide();
    var self = this;
    let id = 'Q' + this.questions.qno + '_' + this.questions.UniqueNumber + '_T_ID'
    let monthNames = this.MonthArray;
    // let monthNames = ["January", "February", "March", "April", "May", "June",
    //   "July", "August", "September", "October", "November", "December"
    // ];
    let qntYears = 82;
    let ddYear = $('#' + id + '_year');
    let ddMonth = $('#' + id + '_month');
    let ddDay = $('#' + id + '_day');

    // let selectMonth = $("#month");
    // let selectDay = $("#day");
    let currentYear = new Date().getUTCFullYear();

    if (this.questions.qsubtype == 1 || this.questions.qsubtype == 2 || this.questions.qsubtype == 3 || this.questions.qsubtype == 4) {
    // for loop for year till 1900 t0 2100
    for (let y = 1900; y < 2100; y++) {
      let date = new Date(currentYear);
      let yearElem;
      yearElem = document.createElement("option");
      yearElem.value = y
      yearElem.textContent = y;
      ddYear.append(yearElem);
      currentYear++;
    };

    // for loop for Month
    for (let m = 0; m < 12; m++) {
      let monthElem;

      monthElem = document.createElement("option");
      monthElem.value = m + 1;
      monthElem.textContent = monthNames[m];
      ddMonth.append(monthElem);
    };
    // for loop for Days
    if((this.questions.qsubtype == 3 || this.questions.qsubtype == 4)&& ddYear.length>0){
      var timeA: any;
    var timeDifference: any;
    timeA = new Date(ddYear[0].options[ddYear[0].selectedIndex].text, ddMonth[0].options[ddMonth[0].selectedIndex].value, 1);
    timeDifference = timeA - 86400000;
    let timeB = new Date(timeDifference);
    var daysInMonth = timeB.getDate();
    for (let d = 1; d <= daysInMonth; d++) {

      let dayElem;

      dayElem = document.createElement("option");
      dayElem.value = d;
      dayElem.textContent = d;
      ddDay.append(dayElem);
    };
  }else{
    for (let d = 1; d < 31; d++) {
      let dayElem;

      dayElem = document.createElement("option");
      dayElem.value = d;
      dayElem.textContent = d;
      ddDay.append(dayElem);
    };
  }


    if (this.questions.qsubtype == 1 || this.questions.qsubtype == 2 || this.questions.qsubtype == 3 || this.questions.qsubtype == 4) {
      this.setDate();
    }

    let dtpContainer = $('#' + id).closest('.date-picker-cont').find('div.dtpContainer');
    let opener = $('#' + id).closest('.date-picker-cont').find('span.dtpOpener');


    let dtpOptions = {
      onSelect: function () {
        $('#' + id).val($(this).val());
        var dt = ($(this).val()).split('/');
        if ($("#" + id + "_MM_ID")) {
          if (self.questions.qsubtype == 2 || self.questions.qsubtype == 4) {
            var mon = parseInt(dt[1]);
            var day = parseInt(dt[0]);
            var year = dt[2];
          }
          else {
            var mon = parseInt(dt[0]);
            var day = parseInt(dt[1]);
            var year = dt[2];
          }
          self.selectedYear = year;
          self.SelectedDate = day;
          self.SelectedMonth = mon;
          $('#' + id + '_month').val(mon).attr("selected", "selected");
          $('#' + id + '_day').val(day).attr("selected", "selected");
          $('#' + id + '_year').val(year).attr("selected", "selected");
        }
        dtpContainer.stop().slideUp();
        //alert($(this).val());
        self.SetControlValue($(this).val(), self);
      },
      changeMonth: true,
      changeYear: true,
      yearRange: "1900:2100",
      dateFormat: this.DateFormat,
      defaultDate: '01/01/1900'
    };
    opener.on('click', function (e) {
      e.stopPropagation();
      dtpContainer.stop().slideToggle();
      $('.dtpContainer').not(dtpContainer).stop().slideUp();
    });
    dtpContainer.on('click', function (e) {
      e.stopImmediatePropagation();
    });



    if (this.questions.qsubtype == 1 || this.questions.qsubtype == 2 ||
      this.questions.qsubtype == 3 || this.questions.qsubtype == 4) {
      $(window).click(function () {
        if ($(dtpContainer).css('display') == 'block') {
          $(dtpContainer).slideUp();
        }
      });
    }else if(this.questions.qsubtype == 71){
      $(window).click(function () {
        $('.attachment-cont').find('.validator_message').hide();
      });
    }


    // $(document).click(function () {
    //   if ($(dtpContainer).css('display') == 'block') {
    //     $(dtpContainer).slideToggle();
    //   }
    // });

    // $(document).click(function() {
    //   $(dtpContainer).css('display') = 'block';
    // });

    if (this.questions.qsubtype == 1) {
      $('#' + id).closest('.date-picker-cont').find('.dtp').datepicker(dtpOptions);
      $('#' + id).closest('.date-picker-cont').find('.dtp').datepicker('setDate',this.setDateText);

    }

    if (this.questions.qsubtype == 2) {
      $('#' + id).closest('.date-picker-cont').find('.dtp').datepicker(dtpOptions);
      $('#' + id).closest('.date-picker-cont').find('.dtp').datepicker('setDate',this.setDateText);
    }

    if (this.questions.qsubtype == 3) {
      $('#' + id).closest('.date-picker-cont').find('.dtp').datepicker(dtpOptions);
      $('#' + id).on('change', function () {
        var dt = ($(this).val()).split('/');
        var mon = dt[0];
        var day = dt[1];
        var year = dt[2];
        $('#' + id + '_month').val(mon).attr("selected", "selected");
        $('#' + id + '_day').val(day).attr("selected", "selected");
        $('#' + id + '_year').val(year).attr("selected", "selected");
      });
      $('#' + id).closest('.date-picker-cont').find('.dtp').datepicker('setDate',this.setDateText);
    }

    if (this.questions.qsubtype == 4) {
      $('#' + id).closest('.date-picker-cont').find('.dtp').datepicker(dtpOptions);
      $('#' + id).on('change', function () {
        var dt = ($(this).val()).split('/');
        var mon = dt[0];
        var day = dt[1];
        var year = dt[2];
        $('#' + id + '_month').val(mon).attr("selected", "selected");
        $('#' + id + '_day').val(day).attr("selected", "selected");
        $('#' + id + '_year').val(year).attr("selected", "selected");
      });
      $('#' + id).closest('.date-picker-cont').find('.dtp').datepicker('setDate',this.setDateText);
    }
  }
    // 508 aria-label
    $(".ui-datepicker-month").attr('aria-label','Month');
    $(".ui-datepicker-year").attr('aria-label','Year');


    if (this.questions.qsubtype == 71 && this.questions.AnswerText != null) {
      $('#btnBrowse_' + this.questions.UniqueNumber).prop("disabled", true);
      $('#File_'+this.questions.qno+'_'+ this.questions.UniqueNumber).prop("disabled", true);
      $("#lnkRemove_" + this.questions.UniqueNumber).css('display', 'block');
      $("#lnkRemove_" + this.questions.UniqueNumber).css('visibility', 'visible');
      $("#lnkRemove_" + this.questions.UniqueNumber).closest('.attach-tb').addClass('delete-on');
      if(this.questions.AnswerText != ""){
        $('#btnBrowse_' + this.questions.UniqueNumber).closest(".desktopfile-icon").addClass("disabled");
      }
    }

    this.isAriaRequired = (this.questions.mandatory && (this.isMandatoryUpfront || this.questions.isMandatoryStar)) || (this.questions.mandatory && this.isFormSubmit && this.questions.isMandatoryInvalid);
    this.resetPageSub = this.service.emitResetPageEvent.subscribe((data) => {
      if(data) {
        this.isAnsChange =false;
        this.resetPage = true;
      }
    });
  }

  ngOnDestroy(){
    this.isFormSubmitSub.unsubscribe();
    if (this.resetPageSub) {
      this.resetPageSub.unsubscribe();
    }
  }

  setURLPrePopText(strPreText: string): string {
    if (strPreText == null || strPreText == undefined) {
      return null;
    }

    let arrWebsiteURL = strPreText.split(".");

    if ((arrWebsiteURL.length >= 3 && arrWebsiteURL[0].toLowerCase() == "www") || strPreText.indexOf("http") == 0) {
      if (strPreText.split(' ').length == 1) {
        if (strPreText.indexOf("http") == 0) {
          return "<a href='" + strPreText + "'  target=_blank>" + strPreText + "</a>"
        } else{
          return "<a href='http://" + strPreText + "'  target=_blank>" + strPreText + "</a>"
        }
      } else {
        if (strPreText.indexOf("http") == 0) {
          return "<a href='" + strPreText.substr(0, strPreText.split(' ')[0].length) +
            "'  target=_blank>" + strPreText.substr(0, strPreText.split(' ')[0].length) + "</a>" +
            "<span>" + strPreText.substr(strPreText.split(' ')[0].length, strPreText.length) + "</span>"
        } else {
          return "<a href='http://" + strPreText.substr(0, strPreText.split(' ')[0].length) +
            "'  target=_blank>" + strPreText.substr(0, strPreText.split(' ')[0].length) + "</a>" +
            "<span>" + strPreText.substr(strPreText.split(' ')[0].length, strPreText.length) + "</span>"
        }
      }
    } else if (strPreText.indexOf("http") >= 0 || strPreText.indexOf("www") >= 0) {
      if (strPreText.indexOf("http") >= 0) {
        if (strPreText.substr(strPreText.split('http')[0].length, strPreText.length).split(' ').length == 1) {
          return "<span>" + strPreText.substr(0, strPreText.split('http')[0].length) + "</span>" + "<a href='" + strPreText.substr(strPreText.split('http')[0].length, strPreText.length) + "'  target=_blank>" + strPreText.substr(strPreText.split('http')[0].length, strPreText.length) + "</a>"
        } else {
          return "<span>" + strPreText.substr(0, strPreText.split('http')[0].length) + "</span>" +
            "<a href='" + strPreText.substr(strPreText.split('http')[0].length, strPreText.length).split(' ')[0] + "'  target=_blank>" +
            strPreText.substr(strPreText.split('http')[0].length, strPreText.length).split(' ')[0] + "</a>" +
            "<span>" + strPreText.substr(strPreText.split('http')[0].length + strPreText.substr(strPreText.split('http')[0].length, strPreText.length).split(' ')[0].length, strPreText.length) + "</span>"
        }
      } else {
        if (strPreText.substr(strPreText.split('www')[0].length, strPreText.length).split(' ').length == 1) {
          return "<span>" + strPreText.substr(0, strPreText.split('www')[0].length) + "</span>" + "<a href='http://" + strPreText.substr(strPreText.split('www')[0].length, strPreText.length) + "'  target=_blank>" + strPreText.substr(strPreText.split('www')[0].length, strPreText.length) + "</a>"
        } else {
          return "<span>" + strPreText.substr(0, strPreText.split('www')[0].length) + "</span>" +
            "<a href='http://" + strPreText.substr(strPreText.split('www')[0].length, strPreText.length).split(' ')[0] + "'  target=_blank>" +
            strPreText.substr(strPreText.split('www')[0].length, strPreText.length).split(' ')[0] + "</a>" +
            "<span>" + strPreText.substr(strPreText.split('www')[0].length + strPreText.substr(strPreText.split('www')[0].length, strPreText.length).split(' ')[0].length, strPreText.length) + "</span>"
        }
      }
    }

    return null;
  }

  //Set date according to date formate
  setDate() {
    let currentDate;
    if (this.questions.qsubtype == 2 || this.questions.qsubtype == 4) {
      this.DateFormat = 'dd/mm/yy';
      this.DateFormatType = 2;
      currentDate = formatDate(new Date(), 'dd/MM/yyyy', 'en');
    }
    else {
      this.DateFormat = 'mm/dd/yy';
      this.DateFormatType = 1;
      currentDate = formatDate(new Date(), 'MM/dd/yyyy', 'en');
    }
    this.DateFormat = (this.DateFormat == '') ? 'mm/dd/yy' : this.DateFormat;

    if ((this.questions.AnswerText != '' && this.questions.AnswerText != null && this.questions.date_default != "current")
    || (this.ControlDate != null && this.questions.date_default != "current")
    ||(this.questions.AnswerText != '' && this.questions.AnswerText != null && this.questions.AnswerText != "current")) {
      this.ControlDate = this.questions.AnswerText;
    }
    else if (this.questions.date_default != null) {
      if (this.questions.date_default == "current") {
        this.ControlDate = currentDate;
      }
      else {
        this.ControlDate = this.questions.date_default;
      }
    }
    if (this.ControlDate != null) {
      var dt = this.ControlDate.split('/');
      var mon, day, yr;
      if (this.DateFormatType == 1) {
        mon = dt[0];
        day = dt[1];
        yr = dt[2];
      }
      else if(this.DateFormatType == 2  && this.questions.date_default != null && this.questions.date_default != "current"  && this.questions.AnswerText == this.questions.date_default && dt[0]!="")
      {
        mon = dt[0];
        day = dt[1];
        yr = dt[2];
        this.ControlDate = day + "/" + mon + "/" + yr;
      }
      else {
        day = dt[0];
        mon = dt[1];
        yr = dt[2];
      }
      this.selectedYear = yr;
      this.SelectedDate = parseInt(day);
      this.SelectedMonth = parseInt(mon);
      this.setDateText = this.ControlDate;

    }

    this.questions.AnswerText = this.ControlDate;

    if (this.questions.AnswerText == "") {
      this.questions.AnswerText = null;
    }
    else
    {
      this.questions.pageto = this.questions.Answers[0].pageto;
    }

    if (this.questions.population_type == 3 && (this.questions.PrePopText == ''||this.questions.PrePopText == null)) {
      this.questions.PrePopText = this.ControlDate;
    }
    this.ChangeLoadingAnswersData.emit(this.questions);
    let id = 'Q' + this.questions.qno + '_' + this.questions.UniqueNumber + '_T_ID'
    $('#' + id).closest('.date-picker-cont').find('.dtp').datepicker('setDate',this.questions.AnswerText);
    this.changeDetect.detectChanges();
  }

  SelectedValue(answer: any) {

    if (answer.target.value === "0") {
      this.questions.isOtherAnswer = false;
      this.questions.selectAnsValue = 0;
      this.questions.AnswerID = 0;
      this.questions.AnswerText = "";
      this.questions.pageto = null;
    } else {
      for (let i = 0; i < this.questions.Answers.length; i++) {
        if (answer.target.value == this.questions.Answers[i].value_id) {
          answer.selectdId = 1;
          //this.questions.Answers[i] = answer;
          this.questions.Answers[i].selectdId = 1;
          this.questions.AnswerID = this.questions.Answers[i].ms_id;
          this.questions.selectAnsValue = this.questions.Answers[i].value_id;
          this.questions.AnswerText = this.questions.Answers[i].value_text;
          this.questions.pageto = this.questions.Answers[i].pageto;
          this.questions.otherAnswer = null;

          if (this.questions.isSoftRequired) {
            this.questions.isSoftRequiredHandle = true;
          }
          if (this.questions.Answers[i].isOther) {
            this.questions.isOtherAnswer = true;
          }
          else {
            this.questions.isOtherAnswer = false;
          }
        }
        else {
          this.questions.Answers[i].ControlAns = null;
          this.questions.Answers[i].selectdId = 0;
        }
      }
    }

    //this.ChangeAnswersData.emit(this.questions);
    this.UpdateQuestionsDataCommon(this.questions);
    let id = 'Q' + this.questions.qno + '_' + this.questions.UniqueNumber + '_T_ID'
    $('#' + id).closest('.date-picker-cont').find('.dtp').datepicker('setDate',this.questions.AnswerText);
  }

  onBlurMethod() {

    if (this.questions.AnswerText != null &&
      this.questions.AnswerText.replace(/\s/g, '') == "") {
      this.questions.AnswerText = null;
    }


    // if(this.questions.population_type == 1)
    // {
    //   this.questions.AnswerText = this.questions.PrePopText;
    // }
    if (this.questions.AnswerText != null && this.questions.AnswerText != "") {
      this.questions.pageto = this.questions.Answers[0].pageto;
    } else {
      this.questions.pageto = 0;
    }

    //this.ChangeAnswersData.emit(this.questions);
    this.UpdateQuestionsDataCommon(this.questions);
  }

  //Show Remaining Characters out of Character Limit
  keytab_remainingChar(event: any, curVal: string) {
    this.isAnsChange=true;
    this.AnsChangecall.emit(this.isAnsChange);
    if (this.questions.Showcharlimit) {
      this.remainingCharacters = this.questions.characterLimit - curVal.length;
    }
  }

  SetControlValue(value: any, self) {
    self.questions.AnswerText = value;
    self.questions.isValid = false;
    self.questions.pageto = this.questions.Answers[0].pageto;
    //self.ChangeAnswersData.emit(this.questions);
    this.UpdateQuestionsDataCommon(this.questions);
  }

  ValidationForSubQuestionType(event: any, curVal: any) {

    if (curVal == "") {
      this.questions.isValid = false;
      this.questions.AnswerText = null;
      this.inValidCount = 0;

      if (this.questions.qsubtype == 31) {
        this.questions.isReEnterEmailValid = false;
        this.questions.isReEnterEmail = true;
        this.questions.otherAnswer = null;
        this.inValidRenterCount = 0;
      }

      //this.ChangeAnswersData.emit(this.questions);
      this.UpdateQuestionsDataCommon(this.questions);
      return;
    }
    // else if(this.questions.population_type == 1)
    // {
    //   this.questions.AnswerText = this.questions.PrePopText;
    // }

    if (this.questions.qsubtype == 22 ||
      this.questions.qsubtype == 41 ||
      this.questions.qsubtype == 21) {
        if(curVal.indexOf(" ") == -1){
          this.NumberValidation(event, curVal);
        }
        else{
          this.questions.isValid = true;
          return;
        }
    }
    else if (this.questions.qsubtype == 11) {
      this.PostalCodeValidation(curVal);
    }
    else if (this.questions.qsubtype == 61 || this.questions.qsubtype == 62) {
      this.PhoneValidation(curVal);
    }
    else if (this.questions.qsubtype == 51) {
      this.SSNValidation(curVal);
    }
    else if (this.questions.qsubtype == 12) {
      this.PostalCodePlusFourValidation(curVal);
    }
    else if (this.questions.qsubtype == 10) {
      this.CustomValidation(curVal);
    }
    else if (this.questions.qsubtype == 31) {
      this.EmailValidation(curVal);
    }
    else if (this.questions.qsubtype == 1 || this.questions.qsubtype == 2 || this.questions.qsubtype == 3 || this.questions.qsubtype == 4) {
      this.ValidateDate(event, curVal);
      this.DatePickerValidation(event, curVal);
      let id = 'Q' + this.questions.qno + '_' + this.questions.UniqueNumber + '_T_ID'
      if(this.questions.isValid){
        let currentDate: Date = new Date();
        $('#' + id).closest('.date-picker-cont').find('.dtp').datepicker('setDate',currentDate);
      }else{
        $('#' + id).closest('.date-picker-cont').find('.dtp').datepicker('setDate',this.questions.AnswerText);
      }
      //$('#' + id).closest('.date-picker-cont').find('.dtp').datepicker('setDate',this.questions.AnswerText);
    }
    else if (this.questions.qsubtype == 63 || this.questions.qsubtype == 64) {
      this.ValidateNumPhone(curVal);
    }
    this.questions.pageto = this.questions.Answers[0].pageto;

    if (this.questions.isValid && this.inValidCount == 0) {
      let control = document.getElementById('Q' + this.questions.qno + '_' + this.questions.UniqueNumber + '_T_ID');
      this.inValidCount++;
      setTimeout(function () {
        control.focus();
      }, 0);
    }

    //this.ChangeAnswersData.emit(this.questions);
    this.UpdateQuestionsDataCommon(this.questions);
  }

  PostalCodePlusFourValidation(curVal: any) {

    if (curVal != "" && (isNaN(curVal) ||
      (curVal.length != 5 && curVal.length < 9) || curVal.length > 9)) {
      this.range = true;
      this.questions.isValid = true;
      return;
    }
    else {
      this.questions.isValid = false;
    }
  }

  EmailValidation(curVal: string) {

    const regexp = new RegExp(/^([a-zA-Z0-9_\.\'\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z])+$/);
    //new RegExp(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/);

    let isValid = regexp.test(curVal);

    if (isValid) {
      this.range = false;
      this.questions.isReEnterEmail = false;
      this.questions.isValid = false;

      if (this.questions.isreenter == 1) {
        let control = document.getElementById('Q' + this.questions.qno + '_' + this.questions.UniqueNumber + '_T_ID_ReEnter');

        setTimeout(function () {
          control.focus();
        }, 0);
      }
    } else {
      this.range = true;
      this.questions.isReEnterEmail = true;
      this.questions.isValid = true;

      this.questions.otherAnswer = null;
      this.questions.isReEnterEmailValid = false;
    }
    this.service.setQuestionChange(this.questions);
  }
  //Compare Email & Re-enter email
  CompareReEnterEmail(event: any, curVal: string) {
    if (curVal == this.questions.AnswerText ||curVal == this.questions.PrePopText) {
      this.questions.isReEnterEmailValid = false;
      this.questions.isValid = false;
    } else {
      if (this.questions.AnswerText == null) {
        this.questions.isValid = false;
        this.questions.AnswerText = null;

        if (this.questions.qsubtype == 31) {
          this.questions.isReEnterEmailValid = false;
          this.questions.isReEnterEmail = true;
          this.questions.otherAnswer = null;
        }
      } else {
        this.questions.isReEnterEmailValid = true;
        this.questions.isValid = true;
        this.questions.pageto = this.questions.Answers[0].pageto;

        if(this.inValidRenterCount == 0){
          let control = document.getElementById('Q' + this.questions.qno + '_' + this.questions.UniqueNumber + '_T_ID_ReEnter');
          this.inValidRenterCount++;
          setTimeout(function () {
            control.focus();
          }, 0);
        }
      }
      this.service.setQuestionChange(this.questions);
    }

    //this.ChangeAnswersData.emit(this.questions);
    this.UpdateQuestionsDataCommon(this.questions);
  }

  PostalCodeValidation(curVal: any) {
    this.range = false;

    if ((curVal != "" && isNaN(curVal)) || curVal.length < 5 || curVal.length > 5) {
      this.range = true;
      this.questions.isValid = true;
      return;
    }
    else {
      this.questions.isValid = false;
    }
  }

  NumberValidation(event: any, curVal: any) {
    this.range = false;
    this.isNegativeCurrencyValue = false;
    let curValue1 = parseFloat(curVal);
    let min1 = parseFloat(this.questions.num_range_1);
    let max1 = parseFloat(this.questions.num_range_2);

    if (curVal != "") {
      if (isNaN(curVal) || (curValue1 < min1 || curValue1 > max1)) {
        this.range = true;
        this.questions.isValid = true;
        return;
      } else if (this.questions.qsubtype == 22 && curValue1 < 0) {
        this.questions.isValid = true;
        this.isNegativeCurrencyValue = true;
        return;
      } else {
        this.questions.isValid = false;

        if (this.questions.AllowOnlyInteger) {
          //this.questions.AnswerText = Math.round(curVal).toString();

          if (Number.isInteger(curValue1) && curVal.indexOf('.') < 0) {
            this.questions.isValid = false;
          } else {
            this.questions.isValid = true;
          }
        }
      }
    } else {
      this.questions.isValid = true;
    }
  }

  PhoneValidation(objTextBox: any) {
    let phone = objTextBox;

    if (phone == "") {
      return true;
    }

    let matchArr1 = phone.match(/^(\d{10})$/);
    let matchArr2 = phone.match(/^(\d{3})-?\d{3}-?\d{4}$/);
    let matchArr3 = phone.match(/^(\d{3})-?\d{7}$/);
    let matchArr4 = phone.match(/^\(\d{3}\)\s\d{3}-\d{4}$/);

    if (matchArr1 != null || matchArr2 != null || matchArr3 != null || matchArr4 != null) {
      if (matchArr4 == null) {
        phone = phone.replace(/-/g, '');
        phone = '(' + phone.substring(0, 3) + ') ' + phone.substring(3, 6) + '-' + phone.substring(6, 10);
      }
      this.questions.AnswerText = phone;
      this.questions.isValid = false;
      this.range = false;
      return true;
    }
    else {
      this.range = true;
      this.questions.isValid = true;
      return false;
    }
  }
  // Validate phone number formate
  ValidateNumPhone(objTextBox: any) {

    let phone = objTextBox;

    if (phone == "") {
      this.questions.isValid = false;
      return;
    }

    var phoneFormat = $(objTextBox).attr('telformat');
    var matchArr1, matchArr2, matchArr3, matchArr4;
    matchArr1 = phone.match(/^(\d{13})$/);
    matchArr2 = phone.match(/^\d{3}\s\d{3}\s\d{3}-\d{4}$/);
    matchArr3 = phone.match(/^\d{3}-?\d{10}$/);
    matchArr4 = phone.match(/^\d{3}-\d{3}-\d{3}-\d{4}$/);
    if (matchArr1 != null || matchArr2 != null || matchArr3 != null || matchArr4 != null) {
      if (matchArr4 == null) {
        phone = phone.replace(/-/g, '');
        if (phoneFormat == 'domestic') {
          phone = '(' + phone.substring(0, 3) + ') ' + phone.substring(3, 6) + '-' + phone.substring(6, 10);
        } else {
          phone = '' + phone.substring(0, 3) + '-' + phone.substring(3, 6) + '-' + phone.substring(6, 9) + '-' + phone.substring(9, 13);
        }
      }

      this.questions.AnswerText = phone;

      this.questions.isValid = false;
    } else {
      this.range = true;
      this.questions.isValid = true;
    }
  }


  SSNValidation(curVal: any) {
    let matchArr1 = curVal.match(/^(\d{9})$/);
    let matchArr2 = curVal.match(/^(\d{3})-?\d{2}-?\d{4}$/);

    if (matchArr1 != null ||matchArr2 != null) {
      this.questions.isValid = false;
    }
    else {
      this.range = true;
      this.questions.isValid = true;
      return;
    }
  }

  CustomValidation(curVal: string) {
    this.VCF(curVal, this.questions.error_msg, this.questions.custom_format, this.questions.custom_format)
  }

  VCF(Tboxvalue, strErrMsg, custom_format, row) {
    if (Tboxvalue.length > 0 && Tboxvalue.length == row.length) {
      for (let i = 0; i < row.length; i++) {
        var TB = Tboxvalue.toString().charAt(i)
        var characters = TB.match(/^[a-zA-Z]*$/)
        var numbers = TB.match(/^[0-9]*$/)
        var RowIndex = row.toString().charAt(i)
        if ((characters == null && RowIndex == "@") || (numbers == null && RowIndex == "#")) {
          var isValid = true
          break;
        } else if ((characters != null && RowIndex == "@") || (numbers != null && RowIndex == "#")) { } else if (TB == RowIndex) { } else {
          var isValid = true
          break;
        }
      }
    } else if (Tboxvalue.length == custom_format.length) {
      for (let i = 0; i < custom_format.length; i++) {
        var TB = Tboxvalue.toString().charAt(i)
        var characters = TB.match(/^[a-zA-Z]*$/)
        var numbers = TB.match(/^[0-9]*$/)
        var RowIndex = custom_format.toString().charAt(i)
        if ((characters == null && RowIndex == "@") || (numbers == null && RowIndex == "#")) {
          var isValid = true
          break;
        } else if ((characters != null && RowIndex == "@") || (numbers != null && RowIndex == "#")) { } else if (TB == RowIndex) { } else {
          var isValid = true
          break;
        }
      }
    } else {
      var isValid = true
    }

    if (isValid) {
      this.range = true;
      this.questions.isValid = true;
      return false;
    } else if (Tboxvalue.length != 0) {
      let Custom = this.CustomForm(custom_format, Tboxvalue)
      this.questions.isValid = false;
      return Custom
    }
  }

  CustomForm(custom_format, Tboxvalue) {
    for (let k = 0; k < custom_format.length; k++) {
      var CustomFormatIndex = custom_format.toString().charAt(k)
      if ((Tboxvalue.length != custom_format.length) &&
        (CustomFormatIndex.match(/^[a-zA-Z]*$/) == null &&
          CustomFormatIndex.match(/^[0-9]*$/) == null)) {

        if (CustomFormatIndex != "@" && CustomFormatIndex != "#") {
          var abc = CustomFormatIndex;
          var strLeft = Tboxvalue.substring(0, k);
          var strRight = Tboxvalue.substring(k + 1, custom_format.length);
          var str = strLeft + abc + strRight
          Tboxvalue = str
        }
      }
    }
    return Tboxvalue
  }

  // date picker validation

  DatePickerValidation(event: any, curVal: any) {
    if (curVal != "" && this.questions.isValid != true) {
      if (isNaN(curVal)) {
        this.questions.isValid = false;
        this.questions.AnswerText = curVal;
        return;
      }
      else {
        this.questions.isValid = false;
      }
    } else {
      this.questions.isValid = true;
    }
  }
  separator: string;
  posDate: any;
  posMonth: any;
  posYear: any;
  lenYear: any;
  setDateVariables(intDateFormatType) {
    switch (intDateFormatType) {
      case 1:
        this.separator = "/"
        this.posDate = 1
        this.posMonth = 0
        this.posYear = 2
        this.lenYear = 4
        break;
      case 2:
        this.separator = "/"
        this.posDate = 0
        this.posMonth = 1
        this.posYear = 2
        this.lenYear = 4
        break;
    }
  }

  isLeapYear(year) {
    return (((year % 4 == 0) && (year % 100 != 0)) || (year % 400 == 0)) ? true : false;
  }

  ValidateDate(event: any, curVal: any) {

    let strDate = curVal;

    this.setDateVariables(this.DateFormatType)

    let arrDate = strDate.split(this.separator)

    if (arrDate.length != 3) {
      // if (objSurvey.isAssessment == 'True') {
      //     if (hours == 0 && mins == 0 && secs == 0) {
      //         //objTextBox.value = '';
      //         return true;
      //     }
      // }
      this.questions.isValid = true;
      return;
    }
    if (arrDate[0] == "" || arrDate[1] == "" || arrDate[2] == "" || arrDate[this.posMonth].length > 2 || arrDate[this.posDate].length > 2 || arrDate[this.posYear].length != this.lenYear || arrDate[this.posYear] < 1753) {
      // if (objSurvey.isAssessment == 'True') {
      //     if (hours == 0 && mins == 0 && secs == 0) {
      //         //objTextBox.value = '';
      //         return true;
      //     }
      // }
      this.questions.isValid = true;
      return;
    }

    if (arrDate[0].length < 2 || arrDate[1].length < 2) {
      this.questions.isValid = true;
      return;
    }

    for (let i = 0; i < arrDate.length; i++) {
      let strTemp = arrDate[i]

      for (let j = 0; j < strTemp.length; j++) {
        if ((strTemp.substring(j, j + 1) == " ") || (isNaN(strTemp.substring(j, j + 1)))) {

          // if (objSurvey.isAssessment == 'True') {
          //     if (hours == 0 && mins == 0 && secs == 0) {
          //         //objTextBox.value = '';
          //         return true;
          //     }
          // }
          this.questions.isValid = true;
          return;
        }
      }
    }

    if ((arrDate[this.posMonth] > 12) || (arrDate[this.posMonth] < 1)) {

      // if (objSurvey.isAssessment == 'True') {
      //     if (hours == 0 && mins == 0 && secs == 0) {
      //         //objTextBox.value = '';
      //         return true;
      //     }
      // }
      this.questions.isValid = true;
      return;
    }

    if (arrDate[this.posMonth] != 2) {
      if ((arrDate[this.posDate] > this.NoOfDays[arrDate[this.posMonth] - 1]) || (arrDate[this.posDate] < 1)) {
        // if (objSurvey.isAssessment == 'True') {
        //     if (hours == 0 && mins == 0 && secs == 0) {
        //         //objTextBox.value = '';
        //         return true;
        //     }
        // }
        this.questions.isValid = true;
        return;
      }
    }
    else {
      if (this.isLeapYear(arrDate[this.posYear])) {
        if (arrDate[this.posDate] > 29 || (arrDate[this.posDate] < 1)) {
          // if (objSurvey.isAssessment == 'True') {
          //     if (hours == 0 && mins == 0 && secs == 0) {
          //         //objTextBox.value = '';
          //         return true;
          //     }
          // }
          this.questions.isValid = true;
          return;
        }
      }
      else {
        if (arrDate[this.posDate] > 28 || (arrDate[this.posDate] < 1)) {

          // if (objSurvey.isAssessment == 'True') {
          //     if (hours == 0 && mins == 0 && secs == 0) {
          //         //objTextBox.value = '';
          //         return true;
          //     }
          // }
          this.questions.isValid = true;
          return;
        }
      }
    }
    this.questions.isValid = false;
  }

  keyup() {
    this.isAnsChange=true;
    this.AnsChangecall.emit(this.isAnsChange);
    this.questions.isValid = false;
  }

  ReEnter_keyup() {
    this.questions.isValid = false;
    this.questions.isReEnterEmailValid = false;

    if (this.questions.otherAnswer == "") {
      this.questions.otherAnswer = null;
    }
  }

  // Fill dropdown date
  pupulate(selectItem: string) {
    //PRT 9381
    let id = 'Q' + this.questions.qno + '_' + this.questions.UniqueNumber + '_T_ID'
    let d = $("#" + id + "_day");
    let m = $("#" + id + "_month");
    let y = $("#" + id + "_year");
    let selectIndex = $("#" + id + selectItem).prop('selectedIndex');
    var timeA: any;
    var timeDifference: any;
    timeA = new Date(y[0].options[y[0].selectedIndex].text, m[0].options[m[0].selectedIndex].value, 1);
    timeDifference = timeA - 86400000;
    let timeB = new Date(timeDifference);
    var daysInMonth = timeB.getDate();
    var selectedDay;
    selectedDay = d[0].selectedIndex;
    if (d.length == daysInMonth) {
      return false;
    }
    for (var i = 0; i < d[0].length; i++) {
      d[0].options[0] = null;
    }
    for (var i = 0; i < daysInMonth; i++) {
      var j = i + 1;
      d[0].options[i] = new Option(j.toString(), j.toString());
    }
    if (i > selectedDay) {
      d[0].options[selectedDay].selected = true;
    } else {
      d[0].options[daysInMonth - 1].selected = true;
      if (document.getElementById("select" + d[0].id)) {
        document.getElementById("select" + d[0].id).innerHTML = daysInMonth.toString();
      }
    }
    if (this.questions.qsubtype == 4) {
      this.setDateText = d[0].value + "/" + m[0].value + "/" + y[0].value;
    }
    else {
      this.setDateText = m[0].value + "/" + d[0].value + "/" + y[0].value;
    }
    this.questions.AnswerText = this.setDateText;
    this.questions.pageto = this.questions.Answers[0].pageto;
    //this.ChangeAnswersData.emit(this.questions);
    this.UpdateQuestionsDataCommon(this.questions);
  }

  isUserExtInvalid: boolean = false;
  handleFileInput(files: FileList, event) {
    $("#loader_" + this.questions.UniqueNumber).css('display', '');
    this.fileToUpload = <File>files[0];
    let surveykey = this.service.getSurveykey();
    let recno = this.service.getRecNO();
    let GroupType = this.service.getGroupType();
    let strStatus = "";

    if (GroupType.toUpperCase() == "PREVIEW") {
      strStatus = "&status=preview";
    }

    let url = 'SurveyData/PostAttachedFile?k=' + surveykey + "&recNo=" + recno + "&qid=" + this.questions.UniqueNumber + strStatus;
    let strMessage = '';
    let formData: FormData = new FormData();
    formData.append('uploadedFiles', this.fileToUpload, this.fileToUpload.name);
    let fileSize = (this.fileToUpload.size / 1024 / 1024);

    if(fileSize > 10 && this.CustomAttachmentSizeSurveyID.indexOf(this.strSurveyID) > -1)
    {
      this.questions.error_msg = "The file to upload cannot exceed 10 MB.";
      this.questions.isValid = true;
      $(event.target).val('');
      $("#loader_" + this.questions.UniqueNumber).css('display', 'none');
      $(event.target).closest('.attachment-cont').find('.validator_message').show();
    }
    if(fileSize > 5 && this.CustomAttachmentSizeSurveyID.indexOf(this.strSurveyID) == -1)
    {
      this.questions.error_msg = "The file to upload cannot exceed 5 MB.";
      this.questions.isValid = true;
      $(event.target).val('');
      $("#loader_" + this.questions.UniqueNumber).css('display', 'none');
      $(event.target).closest('.attachment-cont').find('.validator_message').show();
    }
    else if(this.validateExtension(this.fileToUpload.name))
    {
      this.service.postAttachedFile(url, formData).subscribe(async (data) => {
        strMessage = await data;
        if (strMessage.toUpperCase() == "SUCCESS") {
          this.questions.AnswerText = this.fileToUpload.name.replace(/[+,]/gi, "_");
          this.questions.pageto = this.questions.Answers[0].pageto;
          //this.ChangeAnswersData.emit(this.questions);
          this.UpdateQuestionsDataCommon(this.questions);
          $('#btnBrowse_' + this.questions.UniqueNumber).prop("disabled", "disabled");
          $('#File_'+this.questions.qno+'_'+ this.questions.UniqueNumber).prop("disabled", "disabled");
          $("#loader_" + this.questions.UniqueNumber).css('display', 'none');
          $("#lnkRemove_" + this.questions.UniqueNumber).css('display', 'block');
          $("#lnkRemove_" + this.questions.UniqueNumber).css('visibility', 'visible');
          $("#lnkRemove_" + this.questions.UniqueNumber).closest('.attach-tb').addClass('delete-on');
          $('#btnBrowse_' + this.questions.UniqueNumber).closest(".desktopfile-icon").addClass("disabled")
          this.questions.isValid = false;
        }
        else {
          this.questions.error_msg = strMessage;
          this.questions.isValid = true;
          $(event.target).val('');
          $("#loader_" + this.questions.UniqueNumber).css('display', 'none');
          $(event.target).closest('.attachment-cont').find('.validator_message').show();
        }

      }, error => {
        console.log(error);
      });

    }
    else
    {
      if(this.isUserExtInvalid){
        let dot='.',comma=',';
        let custom_format= this.questions.custom_format.replace(new RegExp(dot.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), "'.").replace(new RegExp(comma.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g'), "',")+"'";
        if(!this.questions.error_msg)
        {
            this.questions.error_msg = `This file extension is not allowed. Allowed file extension(s) are ${custom_format}. Please select a file with allowed extensions and try again.`
        }
        else{
          this.questions.error_msg = this.questions.error_msg.replace('<<ext>>', custom_format)
        }
      }
      else{
        this.questions.error_msg = "This file type is not supported. Please review your entered file type and try again.";
      }
      this.questions.isValid = true;
      $(event.target).val('');
      $("#loader_" + this.questions.UniqueNumber).css('display', 'none');
      $(event.target).closest('.attachment-cont').find('.validator_message').show();
    }

  }

  deleteFile() {
    if (confirm('Are you sure you want to remove the file?')) {
      this.questions.AnswerText = null;
      this.questions.pageto =null;
      //this.ChangeAnswersData.emit(this.questions);
      this.UpdateQuestionsDataCommon(this.questions);
      $('#btnBrowse_' + this.questions.UniqueNumber).prop("disabled", false);
      $('#File_'+this.questions.qno+'_'+ this.questions.UniqueNumber).val('');
      $('#File_'+this.questions.qno+'_'+ this.questions.UniqueNumber).prop("disabled", false);
      $("#lnkRemove_" + this.questions.UniqueNumber).css('display', 'none');
      $("#lnkRemove_" + this.questions.UniqueNumber).css('visibility', 'hidden');
      $("#lnkRemove_" + this.questions.UniqueNumber).closest('.attach-tb').removeClass('delete-on');
      $('#btnBrowse_' + this.questions.UniqueNumber).closest(".desktopfile-icon").removeClass("disabled")
    }
  }


  validateExtension(FileName:string)
  {
    let ext:string;
    let customFormats: any = [];
    let arrFileName = FileName.split('.');
    if(arrFileName.length > 0 )
    {
      ext = arrFileName[arrFileName.length -1];
    }
    var ExtensionArray = ['ZIP','EXE','RAR','MSI','ADE', 'ADP', 'APK', 'BAT', 'CHM', 'CMD', 'COM', 'CPL', 'DLL', 'DMG', 'EXE', 'HTA', 'INS', 'ISP', 'JAR', 'JS', 'JSE', 'LIB', 'LNK', 'MDE', 'MSC', 'MSI', 'MSP', 'MST', 'NSH', 'PIF', 'SCR', 'SCT', 'SHB', 'SYS', 'VB', 'VBE', 'VBS', 'VXD', 'WSC', 'WSF', 'WSH', 'CAB']

    if(this.questions.custom_format != ""){
      customFormats = this.questions.custom_format.split(",").map(format => {
        let extenstionToken = format.split(".");
        return extenstionToken[extenstionToken.length - 1].toUpperCase();
      });
    }

    // Validate System Allowed Extensions
    if(ExtensionArray.indexOf(ext.toUpperCase()) > -1)
    {
      return false;
    }
    // User Allowed Extensions if Any
    else if(customFormats && customFormats.length > 0 && customFormats.indexOf(ext.toUpperCase()) == -1){
      this.isUserExtInvalid = true;
      return false;
    }
    return true
  }

  getTextClass(){
    switch(this.questions.qsubtype){
      case 11:
      case 12:return "zipcode"
      break;
      case 21: return  "number"
      break;
      case 22:return "currency"
      break;
      case 51:return "ssn"
      break;
      case 31:return  "email"
      break;
      case 41: return  "percentage"
      break;
      case 61:return  "phone"
      break;
      default:return ""
      break;
    }
  }

  getCurrencyMessage(){
    return this.service.getCurrencyNegativeMessage();
  }

  clickEvent(event: any) {
    event.preventDefault();
    event.stopPropagation();
  }

  setRemainingCharacters(){
    if (this.questions.Showcharlimit) {
      this.remainingCharacters = this.questions.characterLimit;

      if (this.questions.AnswerText != null) {
        this.remainingCharacters = this.questions.characterLimit - this.questions.AnswerText.length;
      }
    }
  }

  uploadFile(event){
    if(event.keyCode == 13){
      $(`#File_${this.questions.qno}_${this.questions.UniqueNumber}`).click();
    }
  }

  uploadFileclick() {
    $(`#File_${this.questions.qno}_${this.questions.UniqueNumber}`).click();
  }

  keyDown(event: any) {
    if (this.questions.qsubtype == 21 || this.questions.qsubtype == 22
      || this.questions.qsubtype == 51 || this.questions.qsubtype == 41
      || this.questions.qsubtype == 61 || this.questions.qsubtype == 11
      || this.questions.qsubtype == 12) {
      let keyCode = event.which;
      if (keyCode >= 65 && keyCode <= 90) {
        return false;
      }
    }
    this.isAnsChange=true;
    this.AnsChangecall.emit(this.isAnsChange);
    this.UpdateQuestionsData(this.questions)
  }

  UpdateQuestionsData(question: Questions) {
    this.questions = question;
    //this.ChangeAnswersData.emit(question);
    this.UpdateQuestionsDataCommon(question);
  }

  UpdateQuestionsDataCommon(question: Questions) {
    if(question.AnswerText != null){
      this.isAnsChange = true;
      this.AnsChangecall.emit(this.isAnsChange);
    }
    this.ChangeAnswersData.emit(question);
  }

  gotoNextQuestion(question: Questions, event) {
    if(!question.isValid && !(question.isreenter==1 && question.otherAnswer==null && question.AnswerText!=null)){
      if(question.isMatrixQuestion){
        var nextbtnLength = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').length;
        var MatrixelemPosition;
        MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + this.group.Matrix_id)
        //MatrixelemPosition = $(event).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id)
        var MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont')
        if (MatrixelemPosition.length > 0) {
          MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + this.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + this.group.Matrix_id).has('.question-data').eq(0).offset().top;
          //MatrixelemPosition = $(event).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
          //MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont').has('.question-data').eq(0).offset().top;
          $('html,body').animate({
            scrollTop: (MatrixelemPosition - $(window).height() / 3)
          }, 400);
        } else if (MatrixelemPosition1.length > 0) {
          //MatrixelemPosition = $(event).closest('.matrix-mobile-subQ_' + self.group.Matrix_id).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
          //MatrixelemPosition = $(event).nextAll('.matrix-mobile-subQ_' + self.group.Matrix_id).has('.question-data').eq(0).offset().top;
          MatrixelemPosition1 = $(event).closest('.matrix-mobile-subQ-cont').nextAll('.matrix-mobile-subQ-cont').has('.question-data').eq(0).offset().top;
          $('html,body').animate({
            scrollTop: (MatrixelemPosition1 - $(window).height() / 3)
          }, 400);
        } else if (nextbtnLength > 0){
          nextbtnLength = $(event).closest('.active-ques').nextAll('.inactive-ques').has('.question-data').eq(0).offset().top;
          $('html,body').animate({
            scrollTop: (nextbtnLength - $(window).height() / 3)
          }, 400);
        }else{
          var scrollVal = $('.tblPageFooter').offset().top;
          $('html,body').animate({
            scrollTop: scrollVal
          }, 400);
        }
      }else{
        this.service.gotoNextQuestion(question, event) ;
      }
    }
  }

  getTextBoxWidth() {
    let width = this.questions.twidth;
    if (!this.isMobile) {
      if (this.questions.qsubtype == 61 || this.questions.qsubtype == 51) {
        width = 40;
      } else if (this.questions.qsubtype == 22 || this.questions.qsubtype == 11 || this.questions.qsubtype == 12) {
        width = 30;
      } else if (this.questions.qsubtype == 41) {
        width = 20;
      }
    }
    return width + '%';
  }

  gotoNextQuestionKeyboard(question,event) {
    event.preventDefault();
    this.gotoNextQuestion(question,event.target);
  }

  getRemainingChar(): string {
    return this.service.getSurveyMessages().RemainingChr;
  }
}
